Shopify.QuizRedirect = {

  storage: {

  },

  api: {

    urls: {

      test: "https://webhooks.mechanic.dev/63174d5d-7e8b-4be7-944a-a389d22999fe",
      setCustomerTags: "https://webhooks.mechanic.dev/f9605913-01e9-4e40-a893-09217c6aa43d",

    },

    calls: {

      setTags: function(options) {

        if (window.themeVariables.customer.loggedIn != true) {
          return;
        }

        var settings;

        if (typeof options != "undefined") {
          settings = options;
        }

        var data = JSON.parse(localStorage.getItem('quizData'));

        const response = setTags();

        async function setTags() {

          const response = await fetch(Shopify.QuizRedirect.api.urls.setCustomerTags, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify(data),
          })
          .then((response) => {

            if (typeof settings.success == "function") {
              settings.success();
            }

          });
        }

      },

    }

  },

  elements: {

  },

  functions: {

    clearData: function() {

      localStorage.removeItem('quizData');

    },

    storeData: function() {

      var data = JSON.parse(localStorage.getItem('quizData'));

      if (typeof CustomerData != "undefined") {
        data.customer = {
          id: CustomerData.id
        };
      }

      localStorage.setItem('quizData', JSON.stringify(data));

    },

    validateQuizData: function(data) {

      // Basic validation function to check the data array used to submit data
      // to the back-end is well-formed.

      if (typeof data != "object") {
        return false;
      }

      if (typeof data.tags != "object") {
        return false;
      }

      if (!Array.isArray(data.tags)) {
        return false;
      }

      if (data.tags.length < 6) {
        return false;
      }

      return true;

    },

    goToResults: function() {

      let destination = window.themeVariables.routes.quizResults;

      location.href = destination;

    },

    addLoadingOverlay: function() {

      var html = `
      <div class="loading-overlay">
        <div class="loading-overlay__inner">
          <span class="loading-overlay__text h3">Please wait...</span>
        </div>
      </div>
      `;

      var div = document.createElement('div');
      div.innerHTML = html.trim();

      Shopify.QuizRedirect.elements.quiz.appendChild(div.firstChild);

    },

    removeLoadingOverlay: function() {

      var overlay = Shopify.QuizRedirect.elements.quiz.querySelector(".loading-overlay");
      var overlayParent = overlay.parentNode;

      overlay.classList.add("loading-overlay--fade-out");

      var timer = setTimeout(function() {
        overlayParent.removeChild(overlay)
        clearTimeout(timer);
      }, 250);

    }

  },

  init: function() {

    var data = JSON.parse(localStorage.getItem('quizData'));

    if ( Shopify.QuizRedirect.functions.validateQuizData(data) == true && window.themeVariables.customer.loggedIn == true ) {

      Shopify.QuizRedirect.functions.storeData();

      Shopify.QuizRedirect.api.calls.setTags({
        success: function() {
          Shopify.QuizRedirect.functions.goToResults();
        }
      });

    }
    else {
      Shopify.QuizRedirect.functions.goToResults();
    }

  }

}

document.addEventListener("DOMContentLoaded", function(){
  Shopify.QuizRedirect.init();
});
